import React, { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { getUserRoles } from "../utility/authUtils";
import './index.css';

type ProtectedRouteProps = {
  children: ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        navigate("/sign-in");
        return;
      }

      const userRoles = await getUserRoles(currentUser);
      setLoading(false);

      if (!userRoles.includes('super_admin')) {
        await auth.signOut();
        localStorage.clear();
        navigate("/unauthorized");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return <div className="loader-wrapper">
      <div className="loader"></div>
    </div>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;